export default function InfoIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.375 8.375H9V12.75H9.625M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.5C9.51777 6.5 9.9375 6.08027 9.9375 5.5625C9.9375 5.04473 9.51777 4.625 9 4.625C8.48223 4.625 8.0625 5.04473 8.0625 5.5625C8.0625 6.08027 8.48223 6.5 9 6.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
